import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentScanner2Component, DocumentScanner3Component, environment } from '@dabnet-kamu/libs/ui';

@Component({
  selector: 'dk-scanner-manager',
  standalone: true,
  imports: [CommonModule,DocumentScanner2Component,DocumentScanner3Component],
  templateUrl: './scanner-manager.component.html',
  styleUrls: ['./scanner-manager.component.scss'],
})
export class ScannerManagerComponent {
  useVintasoft=environment.isScannerVintasoft;
  @Output() base64Content: EventEmitter<string> = new EventEmitter<string>();
  getScannedContent($e:any){
    this.base64Content.emit($e)
  }
}
